export default __webpack_public_path__ + "images/ibm-logo.a904aecbad2a342f5c9947c58e9ae267.png";